
import { useState } from 'react';

interface ServiceItem {
  name: string;
  description: string;
  price?: string;
}

interface ServicesSectionProps {
  services: { category: string; items: ServiceItem[] }[];
}

export default function ServicesSection({ services }: ServicesSectionProps) {
  const [expandedIdx, setExpandedIdx] = useState<number>(0);

  // Guard against undefined or empty services array
  if (!services || services.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
      <h3 className="text-lg font-bold text-gray-900 mb-5 flex items-center gap-2">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-list-check-2 text-teal-600"></i>
        </div>
        Services &amp; Pricing
      </h3>

      <div className="space-y-3">
        {services.map((section, idx) => (
          <div key={idx} className="border border-gray-100 rounded-xl overflow-hidden">
            <button
              onClick={() => setExpandedIdx(expandedIdx === idx ? -1 : idx)}
              className="w-full flex items-center justify-between px-5 py-3.5 bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <span className="text-sm font-bold text-gray-900 uppercase tracking-wide">
                {section.category}
              </span>
              <i
                className={`ri-arrow-down-s-line text-gray-500 transition-transform duration-200 ${
                  expandedIdx === idx ? 'rotate-180' : ''
                }`}
              ></i>
            </button>

            {expandedIdx === idx && (
              <div className="px-5 py-4 space-y-4">
                {section.items.map((item, itemIdx) => (
                  <div key={itemIdx} className="flex items-start justify-between gap-4">
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-semibold text-gray-900">{item.name}</h4>
                      <p className="text-xs text-gray-500 mt-0.5">{item.description}</p>
                    </div>
                    {item.price && (
                      <span className="text-sm font-bold text-teal-600 whitespace-nowrap">{item.price}</span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <p className="text-xs text-gray-400 mt-4 pt-3 border-t border-gray-100">
        * Prices are estimates and may vary. Contact the business for current pricing.
      </p>
    </div>
  );
}
